// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/spin-entry-practice.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/spin-entry-practice/spin-entry-practice.js';

mount([g0]);
